import * as React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { UserRoleNameEnum } from "../../backend";
import { useUser } from "../../contexts";
import { useTranslation } from "../../i18n";
import { classnames } from "../../utils";
import { Icon } from "../dm";
import * as styles from "./navbar.module.scss";

export const Navbar: React.FC = () => {
  const { user, role, pending } = useUser();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isInvitationPage = pathname.replace(/\/$/, "") === "/invitation";
  const isPressKitPage = pathname.replace(/\/$/, "") === "/downloads-lokale-initiativen";

  const renderAccountLink = (className: string) => {
    if (pending) {
      return null;
    }
    if (user) {
      return (
        <Link className={className || styles.link} activeClassName={styles.active} partiallyActive to="/user/login">
          <Icon name="userCheck" />
          <span className={styles.desktopOnly}>
            {user.name} <sup>{role}</sup>
          </span>
        </Link>
      );
    }
    if (isInvitationPage || isPressKitPage) {
      return null;
    }
    return (
      <Link className={className || styles.link} activeClassName={styles.active} partiallyActive to="/user/login">
        <Icon name="user" />
        {t("navbar.login")}
      </Link>
    );
  };

  return (
    <nav className={styles.base}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <Link to="/">
            {/* Not the .svg twin: it is 11 base64 rasters behind 26 luminance masks and a clip-path
                (1 MB, no actual vector content) and Safari drops the clip-path, so the round logo
                renders as a square. This PNG is 2x for the 100px slot and 29x smaller. */}
            <img
              className={styles.logo}
              src="/images/lust-an-zukunft-logo.png"
              fetchPriority="high"
              alt={t("navbar.logoAlt")}
              width={100}
              height={100}
            />
          </Link>
        </div>
        <div className={styles.nav}>
          {(role === UserRoleNameEnum.Store || role === UserRoleNameEnum.Qa || role === UserRoleNameEnum.Admin) && (
            <>
              <Link
                className={classnames({
                  [styles.link]: true,
                  [styles.active]: pathname.startsWith("/association"),
                })}
                to="/association/overview"
              >
                {t("navbar.associations")}
              </Link>
            </>
          )}
          {(role === UserRoleNameEnum.Gv || role === UserRoleNameEnum.Qa || role === UserRoleNameEnum.Admin) && (
            <>
              <Link className={styles.link} to="/store/overview" activeClassName={styles.active} partiallyActive>
                {t("navbar.stores")}
              </Link>
            </>
          )}
          <Link
            className={!isPressKitPage ? styles.link : styles.pressKitLink}
            to="/hilfe-und-support"
            activeClassName={styles.active}
            partiallyActive
          >
            {t("navbar.helpAndSupport")}
          </Link>
          <Link
            className={!isPressKitPage ? styles.link : styles.pressKitLink}
            to="/teilnahmebedingungen"
            activeClassName={styles.active}
            partiallyActive
          >
            {t("navbar.terms")}
          </Link>
          {renderAccountLink(classnames([styles.link, styles.mobile]))}
        </div>
        <div className={styles.right}>{renderAccountLink(styles.link)}</div>
      </div>
    </nav>
  );
};
